import { GraphQLEnumType } from 'graphql'

export type Role =
  | 'VIEW'
  | 'EDIT'
  | 'RULES_ADMIN'
  | 'ADMIN'
  | 'PLATFORM_ORG_MANAGE'
  | 'PROTECT_EXCLUSIONS_MANAGE'
  | 'PROTECT_POLICIES_MANAGE'
  | 'VIEW_AUDIT_LOGS'

export const role = new GraphQLEnumType({
  name: 'Role',
  description: "Roles used to scope user's permissions",
  values: {
    VIEW: {
      description: 'View Role'
    },
    EDIT: {
      description: 'Edit Role'
    },
    RULES_ADMIN: {
      description: 'Rules Admin Role'
    },
    ADMIN: {
      description: 'Admin Role'
    },
    PLATFORM_ORG_MANAGE: {
      description: 'Platform Org Manage Role'
    },
    PROTECT_EXCLUSIONS_MANAGE: {
      description: 'Protect Exclusions Manage Role'
    },
    VIEW_AUDIT_LOGS: {
      description: 'View Audit Logs Role'
    },
    PROTECT_POLICIES_MANAGE: {
      description: 'Protect Policies Manage Role'
    }
  }
})
